import { globals } from '../utils';
// Polyfill for IE11 and Edge URLSearchParams
export function getParameterByName(name, url) {
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
export function getSkyfireEnvironment() {
    var _a, _b;
    const region = globals.amznMusic.appConfig.siteRegion
        ? globals.amznMusic.appConfig.siteRegion.toLowerCase()
        : 'na';
    const integ = `https://dev-${region}.web.skill.music.a2z.com`;
    const gamma = `https://qa-${region}.web.skill.music.a2z.com`;
    const prod = `https://${region}.web.skill.music.a2z.com`;
    const SKYFIRE_ENVIRONMENTS = {
        local: '',
        // @ts-ignore
        devDesktop: ((_b = (_a = process) === null || _a === void 0 ? void 0 : _a.env) === null || _b === void 0 ? void 0 : _b.devDesktop) || '',
        integ,
        gamma,
        dev: integ,
        qa: gamma,
        prod,
    };
    const DEFAULT_SKYFIRE_ENVIRONMENT_NAME = 'prod';
    const paramSkyfireEnvName = getParameterByName('skyfireEnv', globals.location.href);
    const skyfireEnvironmentName = paramSkyfireEnvName
        ? paramSkyfireEnvName
        : DEFAULT_SKYFIRE_ENVIRONMENT_NAME;
    return SKYFIRE_ENVIRONMENTS[skyfireEnvironmentName.toLowerCase()];
}
